import { ErrorWithCode } from 'types';

export const getErrorName = (e: any) => {
  if (e instanceof Error) {
    const error = e as Error;
    return error.name;
  }
  return '';
};

export const makeErrorWithCode = (msg: string, code: string, name: string) => {
  const err = new Error(msg) as ErrorWithCode;
  err.code = code;
  err.name = name;
  return err;
};
